module.exports = __webpack_public_path__ + "static/media/Sausages.0145305b.png";